module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-4.8308ac03.jpg";